import { VisualReportUpgrade } from './shared/components/visual-report-upgrade';
import { Component, inject, signal, OnInit } from '@angular/core';
import { TUI_ICON_RESOLVER, TuiRoot } from '@taiga-ui/core';
import { TuiProgress } from '@taiga-ui/kit';
import { injectDispatch } from '@ngrx/signals/events';
import { Navigation } from './components/navigation/navigation';
import { AppStore } from './app.store';
import { SessionService } from './shared/services/session.service';
import { SessionTimeoutWarningComponent } from './shared/components/session-timeout-warning/session-timeout-warning';
import { NetworkStatusBannerComponent } from './shared/components/network-status-banner/network-status-banner';
import { NetworkConnectivityService } from './shared/services/network-connectivity.service';
import { globalEvents } from './shared/stores/global.events';

@Component({
  selector: 'app-root',
  imports: [
    Navigation,
    VisualReportUpgrade,
    TuiRoot,
    TuiProgress,
    SessionTimeoutWarningComponent,
    NetworkStatusBannerComponent,
  ],
  providers: [
    {
      provide: TUI_ICON_RESOLVER,
      useFactory: () => {
        const original = inject(TUI_ICON_RESOLVER, { skipSelf: true });

        return (icon: string) =>
          icon.startsWith('@tui.') ? original(icon) : `icons/${icon}.svg`;
      },
    },
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  appStore = inject(AppStore);
  private sessionService = inject(SessionService);
  private networkConnectivity = inject(NetworkConnectivityService);
  protected readonly title = signal('Reverb');

  ngOnInit(): void {
    this.sessionService.initializeSessionMonitoring();
    this.networkConnectivity.initialize();
  }
}
